
import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

const Facebook = {
  subscribeListeners: [] as Array<() => void>,
  // # Subscribe the facebook event without waiting for the FB JS SDK to load
  //  # @param [String] event_name Same event name as FB provided
  //  # @param [Function] callback The callback function passed to FB.Event.subscribe with response as param
  //  #
  //  ## Examples
  //  #window.App.Facebook.subscribe "comment.create", (response) ->
  //  #  console.log "You created comment, data: {id: #{response.commentID}, href: #{response.href}}"
  subscribe(event_name: string, callback: (() => void)) {
    this.subscribeListeners.push(() => {
      WaitObjectByPathPromise("FB")
      .then((FB) => (FB.Event as any).subscribe(event_name, callback))
      .catch(() => {
        // Do nothing, FB can be absent
      })
    })
  },
}

export default Facebook
